import type { TRuleWithTheme } from '@ackee/fela';

export const prevNextButton: TRuleWithTheme = () => ({
    textDecoration: 'none',

    ':hover': {
        textDecoration: 'none',
    },
});
